<template>
  <div class="col-12">
    <div class="row p-0">
      <div class="col-md-10">
        <title-bread-crumb :page="page" />
      </div>
      <div class="col-md-2">
        <ValidationObserver ref="academicYearDropdown">
          <ValidationProvider
            v-slot="{ errors }"
            :rules="`${shouldChooseYear ? 'required' : ''}`"
            name="Grado"
            class="w-25 text-left"
            immediate
          >
            <custom-drop-down
              v-model="selectedAcademicYear"
              placeholder="Seleccionar"
              label="Año Académico:"
              fieldkey="id"
              fieldname="description"
              :options="academicYearList"
              :error="errors[0]"
              custom-error-msg="Favor seleccionar año académico."
              @input="onChangeAcademicYear"
            />
          </ValidationProvider>
        </ValidationObserver>
      </div>
      <div class="dropdown-divider mt-0 pb-2 ml-3 w-100" />
    </div>
    <div class="Sub-menu mb-0">
      <div class="shadow-bottom">
        <ul class="tab-list nav nav-pills nav-fill mb-3" role="tablist">
          <li v-for="item in tabs" :key="item.Id" class="nav-item text-center">
            <a
              class="nav-link ml-0"
              :class="{ active: isActive(item.Name) }"
              href="#tab-i"
              role="tab"
              aria-selected="true"
              aria-controls="tab-i"
              @click.prevent="setActive(item.Id)"
            >
              {{ item.Caption }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-content">
      <keep-alive>
        <component
          :is="activeTab"
          ref="currenTab"
          v-bind="currentProperties"
          :academic-year-id="
            selectedAcademicYear ? selectedAcademicYear.id : null
          "
          :should-chose-year="this.shouldChooseYear"
        />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import TitleBreadCrumb from '@/components/common/page/TitleBreadcrumb.vue';
import CustomDropDown from 'custom-drop-down';
import academicYearService from '@/services/academicyear';
import Tab1 from './tabs/Tab1';
import Tab2 from './tabs/Tab2';

export default {
  name: 'ServiceHistory',
  components: {
    TitleBreadCrumb,
    Tab1,
    Tab2,
    CustomDropDown,
  },

  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Historial de Servicios',
        routes: ['Inicio', 'PEI', 'Historial de Servicios'],
      },
      activeTab: 'Tab1',
      tabs: [
        {
          Id: 'Tab1',
          Name: 'Tab1',
          Caption: 'Ofrecido por la Agencia (SAEE)',
          page: {
            tabIndex: 1,
            icon: 'fas fa-user-edit orange-icon fa-lg',
            title: 'Ofrecido por la Agencia (SAEE)',
            routes: [],
            tooltip: 'Ofrecido por la Agencia (SAEE)',
          },
        },
        {
          Id: 'Tab2',
          Name: 'Tab2',
          Caption: 'Ofrecido por Remedio Provisional',
          page: {
            tabIndex: 2,
            icon: 'fas fa-user-edit orange-icon fa-lg',
            title: 'Ofrecido por Remedio Provisional',
            routes: [],
            tooltip: 'Ofrecido por Remedio Provisional',
          },
        },
      ],
      Tabs: {
        Name: 'Service History Tab',
        Tab1Tab: {
          Name: 'Tab I',
        },
        Tab2Tab: {
          Name: 'Tab II',
        },
      },
      academicYearList: [],
      selectedAcademicYear: null,
    };
  },
  async mounted() {
    const {
      data: response,
    } = await academicYearService.getAcademicYearToFuture();
    if (response) {
      this.academicYearList = response;
    }
    const self = this;
    const { tab } = self.$root.$route.query;
    if (tab) {
      self.activeTab = tab;
    }
  },
  computed: {
    currentProperties: function() {
      return { Info: this.Tabs[this.activeTab + 'Tab'] };
    },
    shouldChooseYear() {
      return this.$store.getters.HasPermission(
        'provider.service.history.required.year.selection'
      );
    },
  },
  methods: {
    isActive(menuItem) {
      return this.activeTab === menuItem;
    },
    async setActive(menuItem) {
      this.activeTab = menuItem;
    },
    onChangeAcademicYear(selected) {
      this.selectedAcademicYear = selected;
    },
  },
};
</script>

<style scoped></style>
